import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  loginWrapper: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: theme.palette.background.default,
    alignItems: 'center',
    height: '100vh',
    '& a': {
      color: theme.palette.primary.main,
      fontSize: '13px',
    },
    '& img': {
      display: 'block',
      margin: 'auto',
    },
    '& .MuiTextField-root': {
      marginBottom: '10px',
    },
  },
  login: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: '400px',
  },
  title: {
    paddingBottom: '20px',
    paddingTop: '40px',
    fontSize: '20px',
    color: theme.palette.text.primary,
  },
  logoContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '24px',
  },
  logoLockup: {
    margin: '0 !important',
    width: '100%',
    maxWidth: '340px',
    height: 'auto',
    display: 'block',
  },
  remember: {
    color: theme.palette.text.primary,
  },
}));

export default useStyles;
